import type { SectionTab } from 'v2/shared/components/section-tabs'

interface ComplianceSubmissionFlags {
  tendlc_submission_enabled?: boolean | null
  tollfree_submission_enabled?: boolean | null
}

export type ComplianceTab = 'drafts' | '10dlc' | 'toll-free'

export const COMPLIANCE_TAB_COPY: Record<ComplianceTab, SectionTab> = {
  '10dlc': { title: '10DLC', description: 'Manage brands and campaigns for US messaging.' },
  'toll-free': {
    title: 'Toll-free verification',
    description: 'Manage toll-free messaging verification.',
  },
  drafts: { title: 'Drafts' },
}

// An explicit `false` hides that registration type; true or an absent flag keeps it visible.
// Compliance is an Enterprise feature, but a non-Enterprise org with either type enabled keeps
// its data, so only one with neither gets the upgrade card instead of the tabs. The page and
// the sidebar both read this.
export const getComplianceTabVisibility = (
  org: ComplianceSubmissionFlags | null | undefined,
  isEnterpriseLocked: boolean,
) => {
  const hide10dlc = org?.tendlc_submission_enabled === false
  const hideTollFree = org?.tollfree_submission_enabled === false
  return { hide10dlc, hideTollFree, showUpgrade: isEnterpriseLocked && hide10dlc && hideTollFree }
}

export type ComplianceTabVisibility = ReturnType<typeof getComplianceTabVisibility>

export const isComplianceTabShown = (tab: ComplianceTab, v: ComplianceTabVisibility) =>
  ({ '10dlc': !v.hide10dlc, 'toll-free': !v.hideTollFree, drafts: !v.showUpgrade })[tab]
